import { cva, VariantProps } from 'class-variance-authority';
import Image from 'next/image';

export const variants = cva(
	[
		'flex',
		'items-center',
		'justify-center',
		'font-semibold',
		'uppercase',
		'relative',
		'overflow-hidden',
		'rounded-full',
	],
	{
		variants: {
			variant: {
				dark: ['bg-dark-600', 'text-white'],
				light: ['bg-white', 'text-dark-600'],
			},
			size: {
				sm: ['size-[16px]', 'rounded-[16px]', 'text-sm'],
				md: ['size-[24px]', 'rounded-[24px]', 'text-sm'],
				lg: ['size-[32px]', 'rounded-[32px]', 'text-sm'],
				xl: ['size-[40px]', 'text-md'],
			},
		},
		compoundVariants: [],
		defaultVariants: {
			variant: 'dark',
			size: 'md',
		},
	},
);

type AvatarDataProps = {
	label?: string;
	alt?: string;
	image?: string;
};

export type AvatarProps = AvatarDataProps &
	VariantProps<typeof variants> & {
		variant?: string;
		size?: string;
	};

const Avatar = ({ label, image, alt, variant, size }: AvatarProps) => {
	return (
		<div className={`${variants({ variant, size })}`}>
			{!image ? (
				<div>{!!label && label?.slice(0, 2)}</div>
			) : (
				<Image src={image} height={100} width={100} alt={alt ?? ''} className={`object-cover ${size}`} />
			)}
		</div>
	);
};

Avatar.displayName = 'Avatar';
export default Avatar;
